import { h } from 'preact'
import tracker from '../../components/tracker/publish'

const eventTrackerHandler = (url: string, title: string, categoryType: string) => {
    tracker.trackEvent('userevent', {
      'type': 'Category Clicked',
      'category_title': title,
      'category_url': url,
      'click_source': 'topic stream',
      'category_type': categoryType
    })
  }

interface Props {
  parentCategoryTitle: string,
  parentCategoryUrl: string,
  parentCategoryId: number,
  categoryTitle: string,
  categoryUrl: string,
}

const TopicBreadcrumb = ({ parentCategoryTitle, parentCategoryUrl, categoryTitle, parentCategoryId, categoryUrl}: Props) => {

  return (
    <span class='thread-meta-item thread-meta-item--hover-highlight thread-meta-item--parent-forum qa-topic-meta-in-subforum'>
      <span class='thread-meta-item__text extra-category-level'>
      <a class='thread-meta-item__link' onClick={() => eventTrackerHandler(`${parentCategoryUrl}`, parentCategoryTitle, 'parent category')} href={parentCategoryUrl}>
        <span>{parentCategoryTitle}</span>
      </a>
      <span> / </span>
      <a class='thread-meta-item__link' onClick={() => eventTrackerHandler(categoryUrl, categoryTitle, 'category')} href={categoryUrl}>
        <span>{categoryTitle}</span>
      </a>
      </span>
    </span>
  )
}

export default TopicBreadcrumb
